<template>
  <div class="news-wrap">
    <div>
      <div class="bannerbox">
        <!-- <el-image fit="cover" :src="require('@/assets/imgs/banner.png')">
                </el-image> -->
        <div class="banner">
          <img
            style="width: 100%; height: auto"
            src="@/assets/imgs/service.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="newsbox">
        <div
          class="clearfix wrap"
          style="padding-top: 60px; padding-bottom: 60px"
        >
          <div class="menutitle">
            <el-breadcrumb separator-class="el-icon-arrow-right">

              <el-breadcrumb-item :to="{ path: '/spectatorService' }"
                >观众服务</el-breadcrumb-item
              >
              <el-breadcrumb-item :to="{ path: '/spectatorService/guide' }"
                >服务指南</el-breadcrumb-item
              >
              <el-breadcrumb-item :to="{ path: '/spectatorService/traffic' }">{{
                "/spectatorService/traffic" === $route.path
                  ? "交通指南"
                  : "/spectatorService/konw" === $route.path
                  ? "参观须知"
                  : "开馆时间"
              }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="newscontent">
            <h3 class="title">{{ list.name }}</h3>
            <p>
              发布日期：{{ list.createTime }} 浏览次数：{{ list.viewCount }}次
            </p>
            <h4 v-html="list.value"></h4>
          </div>
          <div class="service">
            <h3 class="title">观众服务</h3>
            <hr />
            <el-menu :default-openeds="defaultOpeneds">
              <SideBar :list="sideBarData"></SideBar>
            </el-menu>
            <h3 class="title">服务指南</h3>
            <hr />
            <h4 class="til">开馆时间</h4>
            <h5 class="tips" v-if="List[0]" v-html="List[0].value">
              <!-- 友情提示：上饶美术馆周一闭馆（不含节
              假日）疫情期间实行分时预约参观。
              每日可预约时间段如下：9:00-11:00； 11:00-14:00；14:00-16:00<br />
              地址：上饶市信州区平江道60号<br />
              电话：022—83883300 -->
            </h5>
            <h4 class="til">美术馆地址</h4>
            <div class="map">
              <baidu-map
                style="height: 103px"
                @ready="mapHandle"
                :scroll-wheel-zoom="true"
                :key="map.longitude"
              ></baidu-map>
            </div>
            <button @click="gotoMenu()" class="order">参展预约</button>
          </div>
          <!-- <rigthBox
            :list="rigthBoxData"
            :sidebarTitle="sidebarTitle"
          ></rigthBox> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SideBar from "../../components/sideBar";
export default {
  components: {
    SideBar,
  },
  data() {
    return {
      defaultOpeneds: ["menu2"],
      map: {
        longitude: 1,
        latitude: 1,
        address: "",
      },
      sideBarData: [
        {
          name: "参观预约",
          index: "menu1",
          path: `/spectatorService/appointment`,
          children: [],
        },
        {
          name: "服务指南",
          index: "menu2",
          // path: `/spectatorService/guide`,
          children: [
            {
              name: "· 参观须知",
              index: "dataset1",
              path: `/spectatorService/konw`,
              children: [],
            },
            {
              name: "· 开馆时间",
              index: "dataset2",
              path: `/spectatorService/opentime`,
              children: [],
            },
            {
              name: "· 交通指南",
              index: "dataset3",
              path: `/spectatorService/traffic`,
              children: [],
            },
          ],
        },
       {
          name: "电子留言",
          index: "menu3",
          path: `/spectatorService/electronicMessage`,
          children: [],
        },
        {
          name: "在线调查",
          index: "menu4",
          path: `/spectatorService/onlineSurvey`,
          children: [],
        },
      ],

      list: [],
      List: [],
    };
  },
  mounted() {
    var that = this;
    console.log("this", this);
    this.$axios
      .get("/frontapi/service/information/getDetail?name=交通指南")
      .then(
        function (res) {
          console.log(res);
          that.list = res.data.data;
          console.log(that.list, "111");
        },
        function () {
          console.log("请求失败");
        }
      );
    this.$axios
      .get(
        "/frontapi/service/information/list?pageNum=1&pageSize=10&name=开馆时间"
      )
      .then(
        function (res) {
          console.log(res);
          that.List = res.data.rows;
          console.log(that.List, "111");
        },
        function () {
          console.log("请求失败");
        }
      );
    this.$axios({
      method: "get",
      url: "/frontapi/service/information/mapCoordinate",
      data: {},
    }).then((res) => {
      if (res.data.mapCoordinate) {
        var arr = res.data.mapCoordinate.split(",");
        this.map.longitude = parseFloat(arr[0]);
        this.map.latitude = parseFloat(arr[1]);
        this.map.address = res.data.address;
      }
    });
  },
  methods: {
    gotoMenu() {
      //指定跳转的地址 this.$router.replace('/menu')
      this.$router.replace("/spectatorService/appointment");
    },
    mapHandle({ BMap, map }) {
      var point = new BMap.Point(this.map.longitude, this.map.latitude);
      map.centerAndZoom(point, 13);
      var icon = new BMap.Icon(
        require("../../assets/imgs/map-position.png"),
        new BMap.Size(74, 84)
      );
      var marker = new BMap.Marker(point, { icon: icon }); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var html = [];
      var opts = {
        width: 250,
        height: 30,
      };

      html.push('<div class="mapTipWindow"> <ul>');
      html.push("<li>" + this.map.address + "</li>");
      html.push("</ul></div>");
      var infowindow = new BMap.InfoWindow(html.join(""), opts);
      marker.addEventListener("click", function () {
        this.openInfoWindow(infowindow);
      });
    },
  },
};
</script>
<style scoped>
::v-deep .mapTipWindow li {
    font-size: 18px;
}
img {
    font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
}
.news-wrap {
  padding-top:1.111111rem /* 80px -> 1.111111rem */;
  width: 100%;
}
.wrap {
  margin: 0 auto;
  width: 1200px;
  background: #f4f4f4;
}
.banner {
  height: auto;
  width: 100%;
}
.newsbox {
  background: #f4f4f4;
}
.clearfix:after {
  display: block;
  content: "";
  overflow: hidden;
  clear: both;
  height: 0;
}
.news-wrap >>> .menutitle {
  cursor: pointer;
}
.news-wrap >>> .is-link {
  font-weight: 400;
  color: #606266;
  cursor: pointer;
}
.menutitle >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.newscontent {
  width: 860px;
  height: 920px;
  background: #ffffff;
  float: left;
  margin-top: 40px;
  padding-left: 30px;
  border-radius: 10px;
}
.newscontent p {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  line-height: 54px;
  margin-top: 8px;
}
.newscontent h4 {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
}.service {
  width: 309px;
  min-height: 920px;
  background: #ffffff;
  float: right;
  margin-top: 40px;
  padding: 0 30px;
  border-radius: 10px;
}
.title {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
  margin-top: 30px;
}
.til {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
  line-height: 56px;
}
/* .service ul {
  margin-bottom: 70px;
} */
.service li {
  border-bottom: 1px solid #eeeeee;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  line-height: 56px;
  cursor: pointer;
}
.el-submenu__title{
  border-bottom: none;
}
.service .active {
  color: #b78c0d;
}
.service hr {
  height: 1px;
  border: none;
  border-top: 1px solid #222222;
  margin-top: 30px;
}
.tips {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 26px;
}
.order {
  width: 100%;
  height: 40px;
  font-size: 18px;
  border: 1px solid #b78c0d;
  border-radius: 4px 4px 4px 4px;
  background: #fff;
  color: #b78c0d;
  margin-top: 20px;
  margin-bottom: 52px;
  cursor: pointer;
}
</style>
